import { render, staticRenderFns } from "./TimeLineSegment.vue?vue&type=template&id=54573a45&"
import script from "./TimeLineSegment.vue?vue&type=script&lang=js&"
export * from "./TimeLineSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TimeLineSegment.vue"
export default component.exports